export const campaignTemplates = [
  {
    id: 1,
    name: "Engagement",
    description: "Guide visitors to discover products that match their preferences.",
    provider: "EasyChat Team",
    highlights: [
      "Drive product discovery with conversational prompts",
      "Increase engagement with personalized messaging",
      "Ideal for first-time and returning visitors"
    ],
    badge: null,
    previewType: "chatBubble",
    previewTitle: "Hello! 👋",
    previewContent: "Ready to discover more about our products?",
    previewButtons: [],
    bgColor: "#f5f3ff",
    image: "🎯"
  },
  {
    id: 2,
    name: "Sales",
    description: "Offer a special discount to catch visitors before they leave your site.",
    provider: "Revenue Boost Pack",
    highlights: [
      "Capture exit-intent users before they bounce",
      "Show limited-time offers at the right moment",
      "Boost conversion with direct call-to-action"
    ],
    badge: "🔥 Trending",
    previewType: "productImage",
    previewTitle: "Don't go just yet!",
    previewContent: "Enjoy 10% off your order with this discount code",
    previewButtons: [],
    bgColor: "#fecaca",
    image: "🏷️"
  },
  {
    id: 3,
    name: "Product Launch",
    description: "Introduce a new product or feature to spark interest and increase sales.",
    provider: "Launch Studio",
    highlights: [
      "Promote new releases to active visitors",
      "Highlight launch benefits in one popup",
      "Useful for product drops and feature updates"
    ],
    badge: null,
    previewType: "announcement",
    previewTitle: "Introducing our brand new mobile app 📱",
    previewContent: "Download our new app and get exclusive early access to our upcoming collections.",
    previewButtons: [],
    bgColor: "#e9d5ff",
    image: "🚀"
  },
  {
    id: 4,
    name: "Resources",
    description: "Provide resources to showcase offerings and engage visitors.",
    provider: "Content Growth Kit",
    highlights: [
      "Promote guides, catalogs, and downloadable assets",
      "Educate visitors while keeping them on-site",
      "Best for awareness and lead nurturing flows"
    ],
    badge: null,
    previewType: "resource",
    previewTitle: "New collection alert! 🎁",
    previewContent: "Explore our new product catalog and discover our latest offerings!",
    previewButtons: [],
    bgColor: "#d1fae5",
    image: "📚"
  }
];
